import { combineReducers } from 'redux';

import { branchReducer } from './containers/BranchEditing/reducer';
import { settingsGlobalReducer } from './containers/SettingsContainer/reducer';
import { syncFaceIdReducer } from './containers/BranchListContainer/reducer';
import { visitorPhonesTabReducer, visitorsTabReducer } from './containers/VisitorsTabContainer/services/reducer';
import { delayReasonsTabReducer } from './containers/DelayReasonsTabContainer/services/reducer';

export const adiminModuleReducer = combineReducers({
  branchReducer,
  settingsGlobalReducer,
  syncFaceIdReducer,
  visitorsTabReducer,
  visitorPhonesTabReducer,
  delayReasonsTabReducer,
});

export type AdminModuleState = ReturnType<typeof adiminModuleReducer>;
